<template>
    <div class="modal-content aqualina-land-flat-modal-content" :class="{'taunhouses-modal' : modalData.third_floor_img != null}">
        <button class="btn-close-flat-card--modal" @click="closeFlatModal()"><svg-icon icon-class="close" className="icon-close"/></button>
        <div class="col-left">
            <div class="col-navigation">
                <ul>
                    <li :class="{active : floorActive == 1}">
                        <a href="#" @click.prevent="floorActive = 1">1 этаж</a>
                    </li>
                    <li :class="{active : floorActive == 2}">
                        <a href="#" @click.prevent="floorActive = 2">2 этаж</a>
                    </li>
                    <li :class="{active : floorActive == 3}" v-if="modalData.third_floor_img != null">
                        <a href="#" @click.prevent="floorActive = 3">3 этаж</a>
                    </li>
                </ul>
            </div>
            <div class="flat-card-big-img" v-if="floorActive == 1">
                <img :src="modalData.first_floor_img" alt="">
            </div>
            <div class="flat-card-big-img" v-if="floorActive == 2">
                <img :src="modalData.second_floor_img" alt="">
            </div>
            <div class="flat-card-big-img" v-if="floorActive == 3 && modalData.third_floor_img != null">
                <img :src="modalData.third_floor_img" alt="">
            </div>
        </div>
        <div class="col-right">
            <div class="flat-card-top-info">
                <div class="info-item">
                    <h3>{{modalData.name}}</h3>
                    <h4>{{modalData.villa_size}} <span>м²</span></h4>
                </div>
                <div class="info-item">
                    <div class="item">
                        <div class="in">
                            <p>Площадь 1 этажа -</p>
                            <strong>{{modalData.first_floor_size}}<span>м²</span></strong>
                        </div>
                    </div>
                    <div class="item">
                        <div class="in">
                            <p>Площадь 2 этажа -</p>
                            <strong>{{modalData.second_floor_size}}<span>м²</span></strong>
                        </div>
                    </div>
                    <div class="item" v-if="modalData.third_floor_img != null">
                        <div class="in">
                            <p>Площадь 3 этажа -</p>
                            <strong>{{modalData.third_floor_size}}<span>м²</span></strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flat-card-btns-container">
                <div class="flat-btn-print">
                    <a :href="modalData.pdf" donwload target="_blank" class="btn-print">
                        <svg-icon icon-class="print" className="icon-print"/>
                        <p v-if="!this.config[0].mobile">{{flats.land_flats_cards_info.flat_btn_print_name}}</p>
                        <p v-else>{{flats.land_flats_cards_info.flat_btn_print_name_mobile}}</p>
                    </a>
                </div>
                <div class="flat-btn-mail">
                    <a href="#" class="btn-mail" @click.prevent="InputMailInit"  v-if="!formActive"> 
                        <svg-icon icon-class="mail" className="icon-mail"/>
                        <p>{{flats.land_flats_cards_info.flat_btn_mail_name}}</p>
                    </a>
                    <transition name="fade">
                        <formMail v-if="formActive"
                                :options="[{pdf: modalData.pdf, name: modalData.name + ' ' +  modalData.villa_size + 'м²' + ' в ' + CapitalizeID(project) + '.pdf'}]"
                        ></formMail>
                    </transition>
                </div>
                <div class="flat-social-share-btns">
                    <div class="flats-social-share-title">
                        <h4>{{flats.land_flats_cards_info.flat_btn_social_title}}</h4>
                    </div>
                    <button class="button btn-share-flat-to-social btn-share-flat-to-social-desctop" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.name + ' ' +  modalData.villa_size + ' м²' + ' в ' + project" :data-url="modalData.pdf" data-web><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
                    <button class="button btn-share-flat-to-social btn-share-flat-to-social-mobile" data-sharer="whatsapp" :data-title="'Ваша' + ' ' + modalData.name + ' ' +  modalData.villa_size + ' м²' + ' в ' + project" :data-url="modalData.pdf"><svg-icon icon-class="whatsapp-flat" className="flat-share-icon icon-whatsapp"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="telegram" :data-title="'Ваша' + ' ' + modalData.name + ' ' +  modalData.villa_size + ' м²' + ' в ' + project" :data-url="modalData.pdf"><svg-icon icon-class="telegram" className="flat-share-icon icon-telegram"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="facebook" :data-hashtag="'МояКвартира_в_' + project" :data-url="modalData.pdf"><svg-icon icon-class="facebook-flat" className="flat-share-icon icon-facebook"/></button>
                    <button class="button btn-share-flat-to-social" data-sharer="vk" :data-title="'Ваша' + ' ' + modalData.name + ' ' +  modalData.villa_size + ' м²' + ' в ' + project" :data-url="modalData.pdf"><svg-icon icon-class="vk-flat" className="flat-share-icon icon-vk"/></button>
                </div>
            </div>
            <div class="flat-card-form">
                <div class="flat-card-form-titles">
                    <h3>{{form.form_sales_land_flat_title}}</h3>
                    <p>{{form.form_sales_land_flat_desc}}</p>
                </div>
                <formFields class="form-flats-card-setup"></formFields>
            </div>
        </div>
    </div>
</template>

<script>
	import formFields from '@/components/forms/form-flat.vue';
	import formMail from '@/components/forms/form-mail.vue';	
    import {mapGetters} from 'vuex'
	export default {
        name: 'aquqlina-flats-modal',
        props: ['config'],
		components: {
			formFields,
			formMail,
		},
		data () {
			return {
                formActive: this.config[0].active,
                project: window.host,
                floorActive: 1,
			}
        },
        computed: mapGetters({
            form: 'loadForms',
            flats: 'loadSalesCardPage',
			modalData: 'loadSalesLandModalDataArr',
        }),
		methods: {
			closeFlatModal() {
				this.$modal.hide('aqualina_land_flat-card-modal');
            },
            InputMailInit() {
				this.formActive = true;
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
		},
		mounted() {
			// this.$store.watch(
			// 	(state) => state.flatCards,
			// 	(newValue) => {
			// 		if (newValue.length >= 4) {
			// 		}
			// 	}
			// )
		}
	}
</script>

<style lang="scss" scoped>
    @import '@/styles/components/sales/sales-land-partials/partials/aqualina-land-flats-modal.scss';
    @import '@/styles/respond/sales/sales-land-partials/partials/aqualina-land-flats-modal-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/flats-partials/flat-modal-respond.scss';
    @import '@/styles/components/forms/form-flat.scss';
</style>